import { useEffect, useState } from 'react';
import dashboardApi from '../../services/dashboardApi';

export default function useDeviceMapWidgetData(context, { widgetId = null } = {}) {
  const [state, setState] = useState({ isLoading: true, data: null });

  useEffect(() => {
    // `cancelled` guards against a stale response updating state after
    // the component has unmounted or the widgetId has changed mid-flight.
    let cancelled = false;
    if (widgetId == null) {
      setState({ isLoading: false, data: { devices: [] } });
      return undefined;
    }
    setState({ isLoading: true, data: null });

    dashboardApi.deviceMap
      .getData(widgetId)
      .then((res) => {
        if (cancelled) return;
        const body = dashboardApi.unwrapBody(res) || {};
        const devices = (body.deviceList && body.deviceList) || [];
        setState({ isLoading: false, data: { devices } });
      })
      .catch(() => {
        if (cancelled) return;
        // Fail soft: show an empty map instead of crashing the dashboard.
        setState({ isLoading: false, data: { devices: [] } });
      });

    return () => { cancelled = true; };
  }, [widgetId]);

  return state;
}
